"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeDropWidgets = exports.maybeDragWidgets = void 0;
var IsDomElement_1 = require("@CommonFrontend/Utils/IsDomElement/IsDomElement");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var DropLocationStore_1 = require("Project/Stores/DropLocationStore/DropLocationStore");
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var SideBySideActions_1 = require("../SideBySide/SideBySideActions");
var Utils_1 = require("Project/QwilrEditor/Utils");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var lodash_1 = require("lodash");
var Styleable_1 = require("Project/QwilrEditor/WidgetRegistry/Utils/Styleable");
var maybeDragWidgets = function (_a) {
    var _b, _c;
    var editor = _a.editor, event = _a.event, dragStore = _a.dragStore, dropLocationStore = _a.dropLocationStore, providedDragItems = _a.providedDragItems;
    if (!(0, IsDomElement_1.isDOMElement)(event.target))
        return;
    var dragItems = (providedDragItems === null || providedDragItems === void 0 ? void 0 : providedDragItems.length)
        ? providedDragItems
        : dragStore.dragItems.filter(function (dragItem) { return (dragItem === null || dragItem === void 0 ? void 0 : dragItem.type) === DragStore_1.DragType.Widget; });
    if (dragItems.length === 0)
        return;
    var targetNode;
    try {
        targetNode = slate_react_1.ReactEditor.toSlateNode(editor, event.target);
    }
    catch (_d) {
        return;
    }
    var targetPath = slate_react_1.ReactEditor.findPath(editor, targetNode);
    if (slate_1.Editor.isEditor(targetNode))
        return true;
    var dropLocation = null;
    var dragItemsAreCompatibleWithContainer = function (container) {
        var e_1, _a;
        var _b;
        if (slate_1.Editor.isEditor(container[0])) {
            return true;
        }
        var ancestors = __spreadArray([container], __read(slate_1.Node.ancestors(editor, container[1], { reverse: true })), false);
        var containerAllowsDragAndDrop;
        try {
            for (var ancestors_1 = __values(ancestors), ancestors_1_1 = ancestors_1.next(); !ancestors_1_1.done; ancestors_1_1 = ancestors_1.next()) {
                var ancestor = ancestors_1_1.value;
                if (slate_1.Editor.isEditor(ancestor[0])) {
                    containerAllowsDragAndDrop = true;
                    break;
                }
                var config = (0, EditorWidgetRegistry_1.getGenericConfigByType)(ancestor[0].type, true);
                if (((_b = config === null || config === void 0 ? void 0 : config.containerNodeConfiguration) === null || _b === void 0 ? void 0 : _b.allowDragAndDropChildren) != null) {
                    containerAllowsDragAndDrop = config.containerNodeConfiguration.allowDragAndDropChildren;
                    break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (ancestors_1_1 && !ancestors_1_1.done && (_a = ancestors_1.return)) _a.call(ancestors_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (!containerAllowsDragAndDrop) {
            return false;
        }
        return dragItems.every(function (dragItem) { var _a; return (_a = (0, EditorWidgetRegistry_1.getGenericConfigByType)(dragItem.sourceNode.type)) === null || _a === void 0 ? void 0 : _a.validContainers.includes(container[0].type); });
    };
    do {
        var _e = __read(slate_1.Editor.node(editor, targetPath), 1), targetNode_1 = _e[0];
        var targetElement = slate_react_1.ReactEditor.toDOMNode(editor, targetNode_1);
        if (slate_1.Element.isElement(targetNode_1) &&
            ((_b = (0, EditorWidgetRegistry_1.getGenericConfigByType)(targetNode_1.type, true)) === null || _b === void 0 ? void 0 : _b.nodeType) === "layoutElement" &&
            dragItemsAreCompatibleWithContainer([targetNode_1, targetPath])) {
            var lastChildInLayoutPath = __spreadArray(__spreadArray([], __read(targetPath), false), [targetNode_1.children.length - 1], false);
            var lastChildInLayoutEntry = slate_1.Editor.node(editor, lastChildInLayoutPath);
            var lastChildInLayoutBottom = slate_react_1.ReactEditor.toDOMNode(editor, lastChildInLayoutEntry[0]).getBoundingClientRect().bottom;
            if (event.clientY > lastChildInLayoutBottom) {
                dropLocation = slate_1.Path.next(lastChildInLayoutPath);
                continue;
            }
            var firstChildInLayoutPath = __spreadArray(__spreadArray([], __read(targetPath), false), [0], false);
            var firstChildInLayoutEntry = slate_1.Editor.node(editor, firstChildInLayoutPath);
            var firstChildInLayoutTop = slate_react_1.ReactEditor.toDOMNode(editor, firstChildInLayoutEntry[0]).getBoundingClientRect().top;
            if (event.clientY < firstChildInLayoutTop) {
                dropLocation = firstChildInLayoutPath;
                continue;
            }
            return true;
        }
        var containerPath = slate_1.Path.parent(targetPath);
        var _f = __read(slate_1.Editor.node(editor, containerPath), 1), containerNode = _f[0];
        (0, tiny_invariant_1.default)(!slate_1.Text.isText(containerNode), "found text node when looking for a container");
        if (!dragItemsAreCompatibleWithContainer([containerNode, containerPath])) {
            targetPath = slate_1.Path.parent(targetPath);
            continue;
        }
        var _g = targetElement.getBoundingClientRect(), targetTop = _g.top, targetHeight = _g.height;
        var halfwayPoint = targetTop + targetHeight / 2;
        var insertAbove = event.clientY < halfwayPoint;
        dropLocation = insertAbove ? targetPath : slate_1.Path.next(targetPath);
    } while (!dropLocation);
    var dropLocationMatchesSourceLocation = dragItems.length === 1 &&
        ((_c = dragItems[0]) === null || _c === void 0 ? void 0 : _c.sourceEditor) === editor &&
        (slate_1.Path.equals(dragItems[0].sourcePath, dropLocation) ||
            slate_1.Path.equals(slate_1.Path.next(dragItems[0].sourcePath), dropLocation));
    if (dropLocationMatchesSourceLocation) {
        dropLocationStore.clearDropLocation();
    }
    else {
        dropLocationStore.setDropLocation({
            editorId: editor.uniqueId,
            path: dropLocation,
            type: DropLocationStore_1.DropLocationType.BetweenBlocks,
        });
    }
    return true;
};
exports.maybeDragWidgets = maybeDragWidgets;
var maybeDropWidgets = function (_a) {
    var e_2, _b;
    var editor = _a.editor, dragStore = _a.dragStore, dropLocationStore = _a.dropLocationStore, syntheticSelectionStore = _a.syntheticSelectionStore, router = _a.router, conversionElem = _a.conversionElem;
    var dragItems = dragStore.dragItems.filter(function (dragItem) { return (dragItem === null || dragItem === void 0 ? void 0 : dragItem.type) === DragStore_1.DragType.Widget; });
    if (dragItems.length === 0)
        return;
    var dropLocation = dropLocationStore.dropLocation;
    if (!dropLocation || dropLocation.editorId !== editor.uniqueId) {
        dragStore.stopDrag();
        dropLocationStore.clearDropLocation();
        return true;
    }
    var itemsToMove = __spreadArray([], __read(dragItems), false).sort(function (dragItemA, dragItemB) { return slate_1.Path.compare(dragItemA.sourcePath, dragItemB.sourcePath); })
        .map(function (dragItem) { return ({
        editor: dragItem.sourceEditor,
        pathRef: slate_1.Editor.pathRef(dragItem.sourceEditor, dragItem.sourcePath),
        node: slate_1.Editor.node(dragItem.sourceEditor, dragItem.sourcePath)[0],
    }); });
    var mapDragItemToNode = function (item) {
        if (item.editor.uniqueId !== dropLocation.editorId) {
            var cleanedNode = (0, lodash_1.cloneDeep)(item.node);
            (0, Styleable_1.removeStyleOverrides)(cleanedNode);
            return cleanedNode;
        }
        return item.node;
    };
    slate_1.Transforms.insertNodes(editor, itemsToMove.map(mapDragItemToNode), { at: dropLocation.path });
    if (dropLocation.type === DropLocationStore_1.DropLocationType.TwoColumnPlaceholder) {
        var sideBySideNodeEntry = (0, Utils_1.checkAncestors)(editor, dropLocation.path, function (c) { return slate_1.Element.isElement(c) && c.type === "sideBySide"; });
        if (!sideBySideNodeEntry) {
            throw new Error("Tried to dismiss SBS placeholder from drop but no SBS was found");
        }
        (0, SideBySideActions_1.dismissSideBySidePlaceholder)(editor, sideBySideNodeEntry[1]);
    }
    var firstPastedNodePathRef = slate_1.Editor.pathRef(editor, dropLocation.path);
    try {
        for (var itemsToMove_1 = __values(itemsToMove), itemsToMove_1_1 = itemsToMove_1.next(); !itemsToMove_1_1.done; itemsToMove_1_1 = itemsToMove_1.next()) {
            var item = itemsToMove_1_1.value;
            var pathToRemove = item.pathRef.unref();
            if (!pathToRemove)
                continue;
            slate_1.Transforms.removeNodes(item.editor, { at: pathToRemove });
            slate_react_1.ReactEditor.deselect(item.editor);
            slate_react_1.ReactEditor.blur(item.editor);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (itemsToMove_1_1 && !itemsToMove_1_1.done && (_b = itemsToMove_1.return)) _b.call(itemsToMove_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    var insertionPath = firstPastedNodePathRef.unref();
    if (insertionPath) {
        var newSelection_1 = [];
        for (var itemIndex = 0; itemIndex < dragItems.length; itemIndex++) {
            newSelection_1.push({
                editor: editor,
                path: insertionPath,
                router: router,
                conversionElem: conversionElem,
            });
            insertionPath = slate_1.Path.next(insertionPath);
        }
        setTimeout(function () {
            syntheticSelectionStore.setSelection(newSelection_1);
            slate_react_1.ReactEditor.deselect(editor);
            slate_react_1.ReactEditor.blur(editor);
        });
    }
    dragStore.stopDrag();
    dropLocationStore.clearDropLocation();
    return true;
};
exports.maybeDropWidgets = maybeDropWidgets;
